<template>
    <div>
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-col :span="24">
                            <div style="line-height: 3rem; font-size: 1.5rem;">版本更新统计</div>
                        </el-col>

                    </el-row>
                    <el-row style="text-align: left">
                        <el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData">
                            <el-form-item label="当前版本">
                                <el-input @change="changeIndex" style="width: 200px"  placeholder="名称" v-model="searchForm.versionName"   >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="是否更新">
                                <el-select  style="width: 200px" @change="changeIndex"  v-model="searchForm.isUpdate" placeholder="请选择大队">
                                    <el-option :key="0" :label="'未更新'" value="0"></el-option>
                                    <el-option :key="1" :label="'已更新'" value="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="部门">
                                <el-select clearable style="width: 200px" :disabled="deptdisable" @change="changeIndex" filterable v-model="searchForm.bmid"
                                           placeholder="请选择大队">
                                    <el-option
                                            v-for="item in depts"
                                            :key="item.bmid"
                                            :label="item.bmmc"
                                            :value="item.bmid"
                                            :disabled="deptdisable">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item>
                                <el-button @click="searchData()">查询</el-button>


                            </el-form-item>
                        </el-form>
                    </el-row>
                </div>

                <el-table

                        :data="dataList"  v-loading="loading"  style="text-align: center; width: 100%;">
                    <el-table-column prop="username" label="工号" width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="xm" label="姓名"  show-overflow-tooltip>

                    </el-table-column>
                    <el-table-column prop="zzdqcName" label="部门" >
                    </el-table-column>
                    <el-table-column prop="sjhm" label="手机号码" show-overflow-tooltip>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                </el-pagination>
            </el-card>
        </div>


    </div>
</template>
<script>
    import {
        Vue,
        Component
    } from 'vue-property-decorator'

    @Component({
        name: 'tPatrolPlace',
        components:{
        }
    })
    export default class appUpdateInfo extends Vue {
        currentNo = 1;
        pageSize = 10;
        pageTotal = 0;
        dataList=[]
        showInfoVisible=false
        searchForm={
            versionName: '',
            bmid: '',
            isUpdate:'0'
        }
        loading = false;
        dataListSelections=[];
        depts = [];
        deptdisable = false;
        created() {
          this.getDepts()
        }
        getDepts() {
            let that = this;
            this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                params: {
                    userid:this.$store.getters.username
                }

            }).then(res => {
                that.depts = res.data
                if(this.depts && this.depts[0]) {
                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if(zzdyqc != this.CONST_ZN_BM) {
                        var zw = this.$store.getters.user.zw;
                        if(zw) {
                            if(zw=='01'||zw=='02'||zw=='03') {
                                this.searchForm.bmid = that.depts[0].bmid
                                this.deptdisable = true
                                // this.searchData()
                                if(zw !='01') {
                                    // this.childdeptdisable =true;
                                }
                                // this.selectChanged2(this.form.dept)
                            }
                        } else {
                            // this.selectChanged2(this.form.dept)
                        }
                    }


                }
                this.getApkInfo()
            })
        }
        handleSizeChange(val) {
            this.pageSize = val;
            this.searchData();
        }
        handleCurrentChange(val) {
            this.currentNo = val;
            this.searchData();
        }
        deleteHandle (id) {
            let ids = id ? [id] : this.dataListSelections.map(item => {
                return item.id
            })
            if(!ids || ids.length==0) return
            this.$confirm(`确定进行[删除]操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: `/bjba/tpatrolplace/delete`,
                    method: 'post',
                    data: ids
                }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.searchData()
                    } else if(data && data.code ==500) {
                        this.$message({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                })
            }).catch(() => {
            })
        }
        changeIndex(){
            this.currentNo =1
        }
        getParams() {
            this.searchForm.page = this.currentNo;
            this.searchForm.pagesize = this.pageSize
        }
        getApkInfo () {
            this.$request.get('/resource/app/findApkInfo').then(res => {
                const {data} = res
                this.searchForm.versionName = data.data.versionname
            }).then(()=> {
                this.searchData()
            }).catch(err => {
                this.$message({
                    message: '获取版本信息出现异常!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
                console.log(err)
            })
        }
        searchData () {
            this.loading = true
            this.getParams()
            this.$request.get('/bjba/appCount/updateUsers',{params:this.searchForm}).then(res => {
                const {data} = res
                this.loading = false
                this.dataList = data.data.content
                this.pageTotal = data.data.totalElements
            }).catch(err => {
                this.$message({
                    message: '获取列表出现异常!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
            this.loading = false
            console.log(err)
            })
        }

    }
</script>
<style lang="scss" scoped>
    .bcgl {}
</style>
